import { render, staticRenderFns } from "./CreateRecupBonus.vue?vue&type=template&id=451665e4&scoped=true"
import script from "./CreateRecupBonus.vue?vue&type=script&lang=js"
export * from "./CreateRecupBonus.vue?vue&type=script&lang=js"
import style0 from "./CreateRecupBonus.vue?vue&type=style&index=0&id=451665e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451665e4",
  null
  
)

export default component.exports